import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Order, OrderDto } from 'src/app/shared';
import { OrderService } from '../../../feature/services';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartOrdersResolver
  
{
  constructor(private orderService: OrderService) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<(OrderDto | Order)[] | undefined> {
    try {
      const data = await this.orderService.load({ justShoppingCart: true });
      return data;
    } catch (e) {
      return undefined;
    }
  }
}
